import { ChevronRight, ChevronLeft } from "lucide-react";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { INDUSTRY_INSIGHTS } from "../../lib/roiCalculator";

export default function AssessmentSteps({
  steps, currentStep, animating, answers, selectAnswer, canProceed, nextStep, prevStep,
}) {
  return (
    <div data-testid="assessment-steps">
      {/* Progress */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-[#c0cfe0] text-xs">{steps[currentStep].category} ({currentStep + 1}/{steps.length})</span>
          <span className="text-[#0077B3] text-xs font-semibold">{Math.round(((currentStep + 1) / steps.length) * 100)}%</span>
        </div>
        <div className="w-full bg-white/5 h-2 rounded-full">
          <div className="bg-[#0077B3] h-2 rounded-full transition-all duration-500" style={{ width: `${((currentStep + 1) / steps.length) * 100}%` }} />
        </div>
      </div>

      <div className={`transition-all duration-250 ${animating ? "opacity-0 translate-y-3" : "opacity-100 translate-y-0"}`}>
        <div className="flex items-center gap-3 mb-6">
          {(() => { const Icon = steps[currentStep].icon; return <Icon className="w-5 h-5 text-[#0077B3]" />; })()}
          <h3 className="text-white font-bold text-xl" style={{ fontFamily: "Outfit" }}>{steps[currentStep].category}</h3>
        </div>

        {steps[currentStep].questions.map((q) => (
          <div key={q.id} className="mb-6">
            <p className="text-white font-medium text-base mb-3">{q.text}</p>
            <div className="space-y-2">
              {q.options.map((opt, i) => {
                const optText = typeof opt === "string" ? opt : opt.text;
                const isSelected = answers[q.id]?.text === optText;
                return (
                  <button
                    key={optText}
                    data-testid={`q-${q.id}-opt-${i}`}
                    onClick={() => selectAnswer(q.id, opt)}
                    className={`w-full text-left p-4 rounded-md border transition-all text-sm ${
                      isSelected
                        ? "border-[#0077B3] bg-[#0077B3]/10 text-white"
                        : "border-white/8 bg-white/[0.02] text-[#c0cfe0] hover:border-[#0077B3]/50"
                    }`}
                  >
                    {optText}
                  </button>
                );
              })}
            </div>
            {q.id === "industry" && answers.industry?.text && (
              <p data-testid="industry-insight-note" className="mt-3 text-[#0077B3] text-xs bg-[#0077B3]/5 border border-[#0077B3]/20 rounded-md px-3 py-2 leading-relaxed">
                {INDUSTRY_INSIGHTS[answers.industry.text] || INDUSTRY_INSIGHTS["Other"]}
              </p>
            )}
            {q.id === "industry" && answers.industry?.text === "Other" && (
              <div className="mt-3">
                <Input
                  data-testid="other-industry-input"
                  placeholder="Tell us your industry"
                  value={answers.other_industry?.text || ""}
                  onChange={(e) => selectAnswer("other_industry", e.target.value)}
                  className="bg-white/5 border-white/10 text-white placeholder:text-[#c0cfe0]/40 rounded-md h-11"
                />
              </div>
            )}
          </div>
        ))}

        <div className="flex items-center justify-between mt-8">
          {currentStep > 0 ? (
            <button onClick={prevStep} className="flex items-center gap-1 text-[#c0cfe0] hover:text-white text-sm">
              <ChevronLeft className="w-4 h-4" /> Back
            </button>
          ) : <div />}
          <Button
            onClick={nextStep}
            disabled={!canProceed}
            className={`rounded-md font-semibold px-6 h-10 ${canProceed ? "bg-[#0077B3] hover:bg-[#005f8f] text-white" : "bg-white/5 text-white/30 cursor-not-allowed"}`}
          >
            {currentStep < steps.length - 1 ? "Next" : "See Results"} <ChevronRight className="w-4 h-4 ml-1" />
          </Button>
        </div>
      </div>
    </div>
  );
}
